import Search from "./search"
import Sidebar from "./sidebar"

document.addEventListener("DOMContentLoaded", function () {
    Search(jQuery)
    Sidebar(jQuery)
})
